import React from 'react';
import { Text, StyleSheet, ActivityIndicator } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { StackScreenProps } from '@react-navigation/stack';
import { RootStackParamList } from '../navigation/types';

type Props = StackScreenProps<RootStackParamList, 'Loading'>;

export function LoadingScreen({ route }: Props) {
    const { message } = route.params;

    return (
        <SafeAreaView style={styles.container}>
            <ActivityIndicator size="large" color="#22c55e" />
            <Text style={styles.text} accessibilityLiveRegion="polite" allowFontScaling={true} maxFontSizeMultiplier={1.5}>{message}</Text>
        </SafeAreaView>
    );
}

const styles = StyleSheet.create({
    container: { flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#F8FAFC' },
    text: { marginTop: 20, fontSize: 18, fontWeight: '600', color: '#1E293B' }
});
